import { styled } from '@uhg-abyss/web/tools/styled';

export const Button = styled('button', {
  position: 'absolute',
  top: '8px',
  right: '18px',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  zIndex: 1,
});

export const Title = styled('div', {
  fontFamily: 'AbyssUHCSans, Arial, sans-serif',
  fontSize: '18px',
  color: '#FFF',
  fontWeight: 600,
});

export const Description = styled('div', {
  paddingTop: '8px',
  fontFamily: 'AbyssUHCSans, Arial, sans-serif',
  fontSize: '14px',
  color: '#FFF',
});
